import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.date.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
import BannerData from '~/static/banner/data/BannerData.json';
import EventPopUpData from '~/static/banner/data/EventPopUpData.json';
import Nl2br from 'vue-nl2br';
import { useErrorStore } from '@/stores/useErrorStore';
import { useAuthStore } from '@/stores/useAuthStore';
var PageTitle = function PageTitle() {
  return import('~/components/molecules/PageTitle');
};
var SoundSetting = function SoundSetting() {
  return import('~/components/atoms/SoundSetting');
};
var MyPartyItem = function MyPartyItem() {
  return import('~/components/molecules/MyPartyItem');
};
var PickupBannerSwipe = function PickupBannerSwipe() {
  return import('~/components/molecules/PickupBannerSwipe');
};
var NewsBox = function NewsBox() {
  return import('~/components/molecules/NewsBox');
};
var SubMenu = function SubMenu() {
  return import('~/components/molecules/SubMenu');
};
var BeforeLogin = function BeforeLogin() {
  return import('~/components/templates/BeforeLogin');
};
var LandBasicBox = function LandBasicBox() {
  return import('~/components/organisms/LandBasicBox');
};
var Modal = function Modal() {
  return import('~/components/organisms/Modal');
};
var DailyRewardModal = function DailyRewardModal() {
  return import('~/components/organisms/DailyRewardModal');
};
var EventPopUp = function EventPopUp() {
  return import('~/components/organisms/EventPopUp');
};
var MyAssets = function MyAssets() {
  return import('~/components/organisms/MyAssets');
};
var PanelMissionModal = function PanelMissionModal() {
  return import('~/components/organisms/PanelMissionModal');
};
var TermsAgreeModal = function TermsAgreeModal() {
  return import('~/components/organisms/TermsAgreeModal');
};
var LandInfomation = function LandInfomation() {
  return import('~/components/organisms/LandInfomation');
};
export default {
  components: {
    PageTitle: PageTitle,
    SoundSetting: SoundSetting,
    MyPartyItem: MyPartyItem,
    PickupBannerSwipe: PickupBannerSwipe,
    NewsBox: NewsBox,
    SubMenu: SubMenu,
    Nl2br: Nl2br,
    BeforeLogin: BeforeLogin,
    LandBasicBox: LandBasicBox,
    Modal: Modal,
    MyAssets: MyAssets,
    PanelMissionModal: PanelMissionModal,
    TermsAgreeModal: TermsAgreeModal,
    LandInfomation: LandInfomation,
    DailyRewardModal: DailyRewardModal,
    EventPopUp: EventPopUp
  },
  data: function data() {
    return {
      heros: [],
      banners: BannerData,
      eventPopUpDatas: EventPopUpData,
      isMenuShown: false,
      isSwiperShown: false,
      isLandTab: true,
      isLandSectorTab: false,
      landInfo: {},
      guildInfo: {},
      // dailyActionRecommendModalShown: false,
      recommendNotDisplay: false,
      landAssets: [],
      isPanelMissionShown: false,
      panelMission: [],
      panelMissionAchievement: [],
      missionClear: false,
      fgEventPeriod: [],
      raidEventPeriod: [],
      isFetched: false,
      qrAchievementData: [],
      isTermsAgreeModalShown: false,
      isPolygonAgreeModalShown: false,
      landUnRead: false,
      guildUnRead: false,
      warUnRead: false,
      factoryInfo: [],
      trainingInfo: [],
      isQrDataModalShown: false,
      isDailyRewardModalShown: false,
      isWccPopUpModalShown: false,
      isRankEventPopUpModalShown: false,
      isTitleMatchEventPopUpModalShown: false,
      isFgEventPopUpModalShown: false,
      dailyRewardStore: useDailyRewardStore(),
      frontierGateStore: useFrontierGateStore(),
      errorStore: useErrorStore()
    };
  },
  computed: {
    getHero: function getHero() {
      return useHeroStore().getHero;
    },
    isExploreComplete: function isExploreComplete() {
      return useLandMakeStore().isExploreComplete;
    },
    me: function me() {
      return useUserStore().me;
    },
    getLandInfo: function getLandInfo() {
      return useLandStore().getLandInfo;
    },
    getLandSector: function getLandSector() {
      return useLandStore().getLandSector;
    },
    getCurrentLottery: function getCurrentLottery() {
      return useLandStore().getCurrentLottery;
    },
    currentDscInfo: function currentDscInfo() {
      return useDscStore().currentDscInfo;
    },
    currentAllOutWarInfo: function currentAllOutWarInfo() {
      return useAllOutWarStore().getCurrentAllOutWarInfo;
    },
    currentAllOutWarMaster: function currentAllOutWarMaster() {
      return useAllOutWarStore().getCurrentAllOutWarMaster;
    },
    currentElUserInfo: function currentElUserInfo() {
      return useLandCupStore().currentElUserInfo;
    },
    getShownRankMatchMasters: function getShownRankMatchMasters() {
      return useRankMatchStore().getShownRankMatchMasters;
    },
    getShownTitleMatchMasters: function getShownTitleMatchMasters() {
      return useTitleMatchStore().getShownTitleMatchMasters;
    },
    announcement: function announcement() {
      return useAnnouncementStore().getAnnouncements;
    },
    readAt: function readAt() {
      return useAnnouncementStore().getReadAt;
    },
    currentLandCupInfo: function currentLandCupInfo() {
      return useLandCupStore().currentLandCupInfo;
    },
    landCupOngoing: function landCupOngoing() {
      return useLandCupStore().landCupOngoing;
    },
    raid: function raid() {
      return useRaidStore().getRaid;
    },
    isLoggedIn: function isLoggedIn() {
      return useAuthStore().isLoggedIn;
    },
    isAfterSigninFinished: function isAfterSigninFinished() {
      return useAuthStore().isAfterSigninFinished;
    },
    getCurrentFgData: function getCurrentFgData() {
      return this.frontierGateStore.getCurrentFgData;
    },
    guildName: function guildName() {
      return this.guildInfo.alias;
    },
    guildMemberCounts: function guildMemberCounts() {
      return this.guildInfo.membersMap.length;
    },
    guildIcon: function guildIcon() {
      if (this.guildInfo.ipfs.includes('.png')) return "".concat(this.$env.cdnUrl, "/static/land/guildicon/").concat(this.guildInfo.ipfs);else return "".concat(this.$env.cdnUrl, "/user_arts/").concat(this.guildInfo.ipfs);
    },
    isGuildJoined: function isGuildJoined() {
      return this.me.guildId > 0;
    },
    newsData: function newsData() {
      return this.announcement.length <= 5 ? this.announcement : this.announcement.slice(0, 5);
    },
    getLandIconUrl: function getLandIconUrl() {
      return "".concat(this.$env.staticUrl, "/land/landicon/land_icon_").concat(this.me.landType, ".png");
    },
    landName: function landName() {
      if (this.landInfo.name) {
        return this.landInfo.name[this.$i18n.locale];
      }
      return '';
    },
    landCitizensCount: function landCitizensCount() {
      if (this.landInfo.citizensList) {
        return this.landInfo.citizensList.length;
      }
      return 0;
    },
    maxMemberCount: function maxMemberCount() {
      var maxMember = this.guildInfo.maxMember;
      return maxMember.base + maxMember.levelAdd + maxMember.volumeAdd;
    },
    landEmblemTypesList: function landEmblemTypesList() {
      return this.landInfo.emblemTypesList;
    },
    guildEmblemTypesList: function guildEmblemTypesList() {
      return this.guildInfo.emblemTypesList;
    },
    isTrainingComplete: function isTrainingComplete() {
      if (this.trainingInfo.length == 0 || this.trainingInfo.trainingDatasList.length == 0) return false;
      var check = false;
      this.trainingInfo.trainingDatasList.forEach(function (x) {
        if (x.status == 3) check = true;
      });
      return check;
    },
    isFactoryComplete: function isFactoryComplete() {
      if (this.factoryInfo.length == 0 || this.factoryInfo.generatorDatasList.length == 0) return false;
      var check = false;
      this.factoryInfo.generatorDatasList.forEach(function (x) {
        if (x.status == 3) check = true;
      });
      return check;
    },
    isLandMakeComplete: function isLandMakeComplete() {
      return !!this.isExploreComplete || !!this.isFactoryComplete || !!this.isTrainingComplete;
    },
    isPanelMissionCompAll: function isPanelMissionCompAll() {
      return this.panelMission.panelInfosList.every(function (info) {
        return info.state == 4;
      });
    },
    isDscInfo: function isDscInfo() {
      return Object.keys(this.currentDscInfo).length;
    },
    dscName: function dscName() {
      var master = useLandCupMaster().getDscMaster(this.currentDscInfo.dscId);
      return Object.keys(master).length ? master.name[this.$i18n.locale] : '';
    },
    isPicUpEventCount: function isPicUpEventCount() {
      var count = 0;
      if (this.landCupOngoing) count = count + 1;
      if (this.getCurrentFgData.length != 0) count = count + 1;
      if (this.isDscInfo) count = count + 1;
      if (Object.keys(this.raid).length) count = count + 1;
      if (this.getShownTitleMatchMasters.length != 0) count = count + 1;
      if (this.getShownRankMatchMasters.length != 0) count = count + 1;
      if (this.isAllOutWar) count = count + 1;
      if (this.isLottery) count = count + 1;
      return count;
    },
    isAllOutWar: function isAllOutWar() {
      return !!Object.keys(this.currentAllOutWarInfo).length && !!this.currentAllOutWarInfo.warId;
    },
    isLottery: function isLottery() {
      return !!this.getCurrentLottery && !!Object.keys(this.getCurrentLottery).length && this.getCurrentLottery.landLotId != 0;
    },
    fgSince: function fgSince() {
      if (!this.isFetched) return '';
      if (!this.getCurrentFgData.length) return '';
      var locale = this.$i18n.locale;
      var options = {
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      };
      var since = new Date(this.fgEventPeriod.since * 1000).toLocaleString(locale, options);
      return since;
    },
    fgUntil: function fgUntil() {
      if (!this.isFetched) return '';
      if (!this.getCurrentFgData.length) return '';
      var locale = this.$i18n.locale;
      var options = {
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      };
      var until = new Date(this.fgEventPeriod.until * 1000).toLocaleString(locale, options);
      return until;
    },
    raidSince: function raidSince() {
      if (!this.isFetched) return '';
      if (!Object.keys(this.raid).length) return '';
      var locale = this.$i18n.locale;
      var options = {
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      };
      var since = new Date(this.raidEventPeriod.since * 1000).toLocaleString(locale, options);
      return since;
    },
    raidUntil: function raidUntil() {
      if (!this.isFetched) return '';
      if (!Object.keys(this.raid).length) return '';
      var locale = this.$i18n.locale;
      var options = {
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      };
      var until = new Date(this.raidEventPeriod.until * 1000).toLocaleString(locale, options);
      return until;
    },
    allOutWarUnitl: function allOutWarUnitl() {
      if (!this.isFetched) return '';
      if (!Object.keys(this.currentAllOutWarMaster).length) return '';
      var locale = this.$i18n.locale;
      var options = {
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      };
      var until = new Date(this.currentAllOutWarMaster.eventPeriod.until * 1000).toLocaleString(locale, options);
      return until;
    },
    lotteryUnitl: function lotteryUnitl() {
      if (!this.isFetched) return '';
      if (!Object.keys(this.getCurrentLottery).length) return '';
      var locale = this.$i18n.locale;
      var options = {
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      };
      var until = new Date(this.getCurrentLottery.landLotteryMaster.entryPeriod.until * 1000).toLocaleString(locale, options);
      return until;
    },
    unionInfoList: function unionInfoList() {
      return this.currentAllOutWarMaster.unionInfoList;
    },
    dailyRewardInfo: function dailyRewardInfo() {
      return this.dailyRewardStore.getDailyRewardInfo;
    },
    getIsTutorialDone: function getIsTutorialDone() {
      return useUserStore().getIsTutorialDone;
    },
    getCurrentFgDataIndex: function getCurrentFgDataIndex() {
      return useFrontierGateStore().getCurrentFgDataIndex;
    }
  },
  watch: {
    isLoggedIn: {
      handler: function handler(param) {
        var _this = this;
        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var units, checkPos, i, max, ulen, pos, hero, target, idx, heroData, fgIndex;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (!param) {
                  _context.next = 20;
                  break;
                }
                _context.next = 3;
                return useUserStore().fetchUser({
                  uid: _this.me.uid,
                  force: true
                });
              case 3:
                _context.next = 5;
                return Promise.all([_this.dailyRewardStore.fetchDailyRewardInfo(), _this.frontierGateStore.fetchCurrentFrontierGate(), _this.fetchPanelMission(), _this.fetchPanelMissionAchievementStatus(), _this.fetchQrDataList(), _this.eventPopUp(), _this.fetchCurrentLottery()]);
              case 5:
                if (!_this.dailyRewardInfo.isClaimed) {
                  _this.isDailyRewardModalShown = true;
                }
                _context.next = 8;
                return useDeckTemplateStore().fetchDeckTemplates();
              case 8:
                units = useDeckTemplateStore().getDeckTemplates[0].unitsList || [];
                checkPos = [1, 2, 3, 4, 5];
                i = 0, max = 5, ulen = units.length;
                for (; i < max; i++) {
                  pos = 0;
                  hero = null;
                  target = '';
                  if (i < ulen) {
                    pos = units[i].position;
                    // delete pos from check
                    idx = checkPos.indexOf(pos);
                    checkPos.splice(idx, 1);
                    hero = _this.getHero(units[i].heroId);
                    target = '/units/' + hero.heroId;
                  }
                  // make empty data with left position
                  else {
                    pos = checkPos[0];
                    checkPos.splice(0, 1);
                  }
                  heroData = {
                    imageUrl: hero != null ? hero.imageUrl : '',
                    position: pos,
                    attribute: hero != null ? hero.attribute : 0,
                    jumpTo: target,
                    name: hero != null ? hero.name : '',
                    lv: hero != null ? hero.lv : '-',
                    rarity: hero != null ? hero.rarity : 99,
                    lbLevel: hero != null ? hero.lbLevel : 0,
                    exAscensionPhase: hero != null ? hero.exAscensionPhase : 0,
                    exAscensionLevel: hero != null ? hero.exAscensionLevel : 0
                  };
                  _this.heros.push(heroData);
                }

                // sort asscending order by position
                _this.heros.sort(function (x, y) {
                  if (x.pos < y.pos) return -1;
                  if (x.pos > y.pos) return 1;
                  return 0;
                });
                _this.isSwiperShown = true;
                //   //- 探索結果取得
                _context.next = 16;
                return useLandMakeStore().fetchExploreResults();
              case 16:
                fgIndex = _this.getCurrentFgDataIndex;
                if (_this.getCurrentFgData.length && fgIndex != -1) _this.fgEventPeriod = _this.getCurrentFgData[fgIndex].eventPeriod;
                if (Object.keys(_this.raid).length) _this.raidEventPeriod = _this.raid.raidTypeMaster.eventPeriod;
                _this.isFetched = true;
              case 20:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }))();
      }
    },
    getIsTutorialDone: {
      handler: function handler() {
        var _this2 = this;
        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.fetchPanelMission();
              case 2:
                _context2.next = 4;
                return _this2.fetchPanelMissionAchievementStatus();
              case 4:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }))();
      }
    }
  },
  beforeMount: function beforeMount() {
    var _this3 = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var units, checkPos, i, max, ulen, pos, hero, target, idx, heroData, fgIndex;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!(_this3.isLoggedIn == false)) {
              _context3.next = 2;
              break;
            }
            return _context3.abrupt("return");
          case 2:
            _context3.next = 4;
            return useUserStore().fetchUser({
              uid: _this3.me.uid,
              force: true
            });
          case 4:
            _context3.next = 6;
            return Promise.all([_this3.dailyRewardStore.fetchDailyRewardInfo(), _this3.frontierGateStore.fetchCurrentFrontierGate(), _this3.fetchPanelMission(), _this3.fetchPanelMissionAchievementStatus(), _this3.fetchQrDataList(), _this3.eventPopUp(), _this3.fetchCurrentLottery()]);
          case 6:
            if (!_this3.dailyRewardInfo.isClaimed) {
              _this3.isDailyRewardModalShown = true;
            }

            //- 利用規約同意チェック
            if (!_this3.me.agree20200910) _this3.isTermsAgreeModalShown = true;
            // if (!this.me.agree20210520) this.isPolygonAgreeModalShown = true

            // もう総力戦やってない
            // await this.fetchCurrentAllOutWarInfo()
            // if (!!Object.keys(this.currentAllOutWarInfo).length && !!this.currentAllOutWarInfo.warId) {
            //   await this.fetchCurrentAllOutWarMaster(this.currentAllOutWarInfo.warId)
            // }
            _context3.next = 10;
            return useDeckTemplateStore().fetchDeckTemplates();
          case 10:
            units = useDeckTemplateStore().getDeckTemplates[0].unitsList || [];
            checkPos = [1, 2, 3, 4, 5];
            i = 0, max = 5, ulen = units.length;
            for (; i < max; i++) {
              pos = 0;
              hero = null;
              target = '';
              if (i < ulen) {
                pos = units[i].position;
                // delete pos from check
                idx = checkPos.indexOf(pos);
                checkPos.splice(idx, 1);
                hero = _this3.getHero(units[i].heroId);
                target = '/units/' + hero.heroId;
              }
              // make empty data with left position
              else {
                pos = checkPos[0];
                checkPos.splice(0, 1);
              }
              heroData = {
                imageUrl: hero != null ? hero.imageUrl : '',
                position: pos,
                attribute: hero != null ? hero.attribute : 0,
                jumpTo: target,
                name: hero != null ? hero.name : '',
                lv: hero != null ? hero.lv : '-',
                rarity: hero != null ? hero.rarity : 99,
                lbLevel: hero != null ? hero.lbLevel : 0,
                exAscensionPhase: hero != null ? hero.exAscensionPhase : 0,
                exAscensionLevel: hero != null ? hero.exAscensionLevel : 0
              };
              _this3.heros.push(heroData);
            }

            // sort asscending order by position
            _this3.heros.sort(function (x, y) {
              if (x.pos < y.pos) return -1;
              if (x.pos > y.pos) return 1;
              return 0;
            });

            // await useAnnouncementStore().fetchAnnouncements()

            //- デイリーボーナス受け取りチェック
            // const dairyActionStatus = await this.$usersService.getDairyActionStatus()
            // if (dairyActionStatus == 0) {
            //   this.dailyActionRecommendModalShown = true
            // }

            _this3.isSwiperShown = true;

            // if (this.me.landType != 0) {
            //   await this.fetchLandInfo({ landType: this.me.landType, force: true })
            //   this.landInfo = this.getLandInfo(this.me.landType)
            //
            //   if (this.me.guildId > 0) {
            //     this.guildInfo = await this.$landGuildService.GetGuildInfo(this.me.guildId)
            //     let checkTime = this.$localStorage.get('bfh:guildBulletinBoardTime')
            //     if (checkTime) {
            //       let msgs = await this.$landGuildService.GetMessages(this.me.guildId)
            //       if (msgs.messageDatasList.length) {
            //         msgs.messageDatasList.sort((p, c) => {
            //           if (p.at > c.at) return -1
            //           if (p.at < c.at) return 1
            //           return 0
            //         })
            //         if (checkTime < msgs.messageDatasList[0].at) {
            //           this.guildUnRead = true
            //         }
            //       }
            //     } else {
            //       this.guildUnRead = true
            //     }
            //   }
            //
            //   //- 探索結果取得
            _context3.next = 18;
            return useLandMakeStore().fetchExploreResults();
          case 18:
            //   //- ファクトリー結果取得
            //   await useLandMakeStore().fetchLandMakeInfo()
            //   if (useLandMakeStore().getActiveLandType(this.getFacilityTypes.FACTORY))
            //     this.factoryInfo = await this.$landMakeService.getCurrentFactory()
            //   if (useLandMakeStore().getActiveLandType(this.getFacilityTypes.TRAINING))
            //     this.trainingInfo = await this.$landMakeService.getCurrentTraining()
            //
            //   let checkTime = this.$localStorage.get('bfh:landBulletinBoardTime')
            //   if (checkTime) {
            //     let msgs = await this.$landService.getLandMessages(this.me.landType)
            //     if (msgs) {
            //       if (msgs.messageList.length) {
            //         msgs.messageList.sort((p, c) => {
            //           if (p.at > c.at) return -1
            //           if (p.at < c.at) return 1
            //           return 0
            //         })
            //         if (checkTime < msgs.messageList[0].at) {
            //           this.landUnRead = true
            //         }
            //       }
            //     }
            //   } else {
            //     this.landUnRead = true
            //   }
            //
            //   let warCheckTime = this.$localStorage.get('bfh:warBoardTime')
            //   if (this.isAllOutWar && !!warCheckTime) {
            //     let data = {
            //       warId: this.currentAllOutWarInfo.warId,
            //       unionId: this.unionInfoList.find(x => x.idsList.includes(this.me.landType)).unionId,
            //       lang: null,
            //     }
            //     let msgs = await this.$landCupsService.getAllOutWarMessages(data, 0, 1000)
            //     if (msgs) {
            //       if (msgs.messageList.length) {
            //         msgs.messageList.sort((p, c) => {
            //           if (p.at > c.at) return -1
            //           if (p.at < c.at) return 1
            //           return 0
            //         })
            //         if (warCheckTime < msgs.messageList[0].at) {
            //           this.warUnRead = true
            //         }
            //       }
            //     }
            //   } else {
            //     this.warUnRead = true
            //   }
            // }
            // await this.fetchMyLandSectors()
            fgIndex = _this3.getCurrentFgDataIndex;
            if (_this3.getCurrentFgData.length && fgIndex != -1) _this3.fgEventPeriod = _this3.getCurrentFgData[fgIndex].eventPeriod;
            if (Object.keys(_this3.raid).length) _this3.raidEventPeriod = _this3.raid.raidTypeMaster.eventPeriod;
            if (_this3.isAfterSigninFinished) {
              _context3.next = 24;
              break;
            }
            _context3.next = 24;
            return _this3.logout();
          case 24:
            _this3.isFetched = true;
          case 25:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  },
  methods: {
    fetchLandInfo: function fetchLandInfo(arg) {
      return useLandStore().fetchLandInfo(arg);
    },
    fetchLandSectors: function fetchLandSectors(ids) {
      return useLandStore().fetchLandSectors(ids);
    },
    fetchCurrentLottery: function fetchCurrentLottery() {
      return useLandStore().fetchCurrentLottery();
    },
    fetchCurrentAllOutWarInfo: function fetchCurrentAllOutWarInfo() {
      return useAllOutWarStore().fetchCurrentAllOutWarInfo();
    },
    fetchCurrentAllOutWarMaster: function fetchCurrentAllOutWarMaster(id) {
      return useAllOutWarStore().fetchCurrentAllOutWarMaster(id);
    },
    fetchCurrentUserInfo: function fetchCurrentUserInfo() {
      return useLandCupStore().fetchCurrentUserInfo();
    },
    closePolygonModal: function closePolygonModal() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this4.$usersService.agree20210520();
            case 2:
              _this4.isPolygonAgreeModalShown = false;
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    readPolygonMedium: function readPolygonMedium() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this5.$usersService.agree20210520();
            case 2:
              if (_this5.$i18n.locale === 'ja') {
                window.open('https://medium.com/bravefrontierheroes/polygon-network-5c02eec0b7d8', '_blank');
              } else {
                window.open('https://medium.com/bravefrontierheroes/polygon-network-en-88cf64d0fb89', '_blank');
              }
              _this5.isPolygonAgreeModalShown = false;
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    fetchPanelMission: function fetchPanelMission() {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!_this6.getIsTutorialDone) {
                _context6.next = 5;
                break;
              }
              _context6.next = 3;
              return _this6.$usersService.getCurrentPanelMission();
            case 3:
              _this6.panelMission = _context6.sent;
              if (_this6.panelMission.state == 3 && !_this6.isPanelMissionCompAll) {
                _this6.isPanelMissionShown = true;
                _this6.missionClear = true;
              } else if (_this6.panelMission.state == 1) {
                _this6.isPanelMissionShown = true;
              }
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    fetchPanelMissionAchievementStatus: function fetchPanelMissionAchievementStatus() {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (!_this7.getIsTutorialDone) {
                _context7.next = 4;
                break;
              }
              _context7.next = 3;
              return _this7.$achievementService.CheckUserAchievementMissionByAchievementMasterId(_this7.$constants.ACHIEVEMENT.PanelMission);
            case 3:
              _this7.panelMissionAchievement = _context7.sent;
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    fetchQrDataList: function fetchQrDataList() {
      var _arguments = arguments,
        _this8 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var panelClose, val, viewedData;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              panelClose = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;
              val = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : false;
              if (!(_this8.$i18n.locale === 'ja')) {
                _context8.next = 9;
                break;
              }
              _context8.next = 5;
              return useUserStore().fetchQrData();
            case 5:
              if (panelClose) _this8.isPanelMissionShown = val;
              if (!_this8.isPanelMissionShown && !_this8.missionClear) {
                _this8.qrAchievementData = [];
                useUserStore().getQrData.forEach(function (q) {
                  q.qrCodeDatasList.forEach(function (x) {
                    if (x.allocateCode) {
                      var setData = {
                        type: q.qrType,
                        qrCodeDatasList: x,
                        image: q.image
                      };
                      _this8.qrAchievementData.push(setData);
                    }
                  });
                });
                if (_this8.qrAchievementData.length) {
                  viewedData = _this8.$localStorage.get('viewed-qr-data');
                  if (viewedData) _this8.qrAchievementData = _this8.qrAchievementData.filter(function (x) {
                    return !viewedData.includes(x.qrCodeDatasList.qrId);
                  });
                  if (_this8.qrAchievementData.length) _this8.isQrDataModalShown = true;
                }
              }
              _context8.next = 10;
              break;
            case 9:
              if (panelClose) _this8.isPanelMissionShown = val;
            case 10:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    visitQrPage: function visitQrPage() {
      var viewedData = this.$localStorage.get('viewed-qr-data');
      if (!viewedData) viewedData = [];
      this.qrAchievementData.forEach(function (x) {
        viewedData.push(x.qrCodeDatasList.qrId);
      });
      this.$localStorage.set('viewed-qr-data', viewedData);
      this.$router.push(this.localePath('qrcode'));
    },
    visitCampaignPage: function visitCampaignPage() {
      var viewedData = this.$localStorage.get('viewed-campaign-data1');
      if (!viewedData) viewedData = [];
      this.$localStorage.set('viewed-campaign-data1', true);
      this.$router.push(this.localePath('campaign'));
    },
    fetchMyLandSectors: function fetchMyLandSectors() {
      var _this9 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var landSectorIds, landSectors, i;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return _this9.$landService.getLandSectorIds(_this9.me.uid);
            case 2:
              landSectorIds = _context9.sent;
              if (!(landSectorIds != null)) {
                _context9.next = 10;
                break;
              }
              _context9.next = 6;
              return _this9.fetchLandSectors(landSectorIds);
            case 6:
              landSectors = landSectorIds.map(function (id) {
                return _this9.getLandSector(id);
              });
              _this9.landAssets = _this9.$util.clone(landSectors);
              i = 0;
              landSectors.forEach(function (ls) {
                var masterData = useLandMaster().getSectorMaster(ls.landSectorType);
                _this9.landAssets[i].rarity = masterData.rarity;
                _this9.landAssets[i].landType = masterData.landType;
                i++;
              });
            case 10:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    onToggleMenu: function onToggleMenu() {
      this.isMenuShown = !this.isMenuShown;
    },
    onMyLand: function onMyLand() {
      this.$router.push("".concat(this.$i18n.locale == 'ja' ? '/ja' : '', "/land/").concat(this.me.landType));
    },
    onMyLandSectors: function onMyLandSectors() {
      this.$router.push("".concat(this.$i18n.locale == 'ja' ? '/ja' : '', "/land/sectors/ingame"));
    },
    onMyGuild: function onMyGuild() {
      this.$router.push("".concat(this.$i18n.locale == 'ja' ? '/ja' : '', "/land/guild"));
    },
    onLandMake: function onLandMake() {
      this.$router.push("".concat(this.$i18n.locale == 'ja' ? '/ja' : '', "/land/make"));
    },
    onWorldMap: function onWorldMap() {
      this.$router.push("".concat(this.$i18n.locale == 'ja' ? '/ja' : '', "/land/worldmap"));
    },
    dailyActionRecommendClick: function dailyActionRecommendClick() {
      this.setDairyActionStatus();
      this.$router.push("".concat(this.$i18n.locale == 'ja' ? '/ja' : '', "/zelshop/purchase"));
    },
    setDairyActionStatus: function setDairyActionStatus() {
      var _this10 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.prev = 0;
              if (!_this10.recommendNotDisplay) {
                _context10.next = 4;
                break;
              }
              _context10.next = 4;
              return _this10.$usersService.setDairyActionStatus();
            case 4:
              _context10.next = 9;
              break;
            case 6:
              _context10.prev = 6;
              _context10.t0 = _context10["catch"](0);
              console.log(_context10.t0);
            case 9:
            case "end":
              return _context10.stop();
          }
        }, _callee10, null, [[0, 6]]);
      }))();
    },
    dailyActionRecommendModalClose: function dailyActionRecommendModalClose() {
      this.setDairyActionStatus();
      this.dailyActionRecommendModalShown = false;
    },
    matchSince: function matchSince(m) {
      if (!this.isFetched) return '';
      if (!this.getShownRankMatchMasters.length && m == 1) return '';
      if (!this.getShownTitleMatchMasters.length && m == 2) return '';
      var locale = this.$i18n.locale;
      var options = {
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      };
      var date = m == 1 ? this.getShownRankMatchMasters[0].eventPeriod.since : this.getShownTitleMatchMasters[0].eventPeriod.since;
      var since = new Date(date * 1000).toLocaleString(locale, options);
      return since;
    },
    matchUntil: function matchUntil(m) {
      if (!this.isFetched) return '';
      if (!this.getShownRankMatchMasters.length && m == 1) return '';
      if (!this.getShownTitleMatchMasters.length && m == 2) return '';
      var locale = this.$i18n.locale;
      var options = {
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      };
      var date = m == 1 ? this.getShownRankMatchMasters[0].eventPeriod.until : this.getShownTitleMatchMasters[0].eventPeriod.until;
      var until = new Date(date * 1000).toLocaleString(locale, options);
      return until;
    },
    eventPopUp: function eventPopUp() {
      var _this11 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var _this11$currentElUser, isEntryPeriod, titleMatchList, titleMatchJoined, currentFgList, fgJoined, currentFgRankInfo;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              if (!_this11.landCupOngoing) {
                _context12.next = 5;
                break;
              }
              _context12.next = 3;
              return _this11.fetchCurrentUserInfo();
            case 3:
              isEntryPeriod = _this11.$dayjs().isSameOrBefore(_this11.$dayjs(_this11.currentLandCupInfo.entryPeriod.until * 1000));
              if (!((_this11$currentElUser = _this11.currentElUserInfo) !== null && _this11$currentElUser !== void 0 && _this11$currentElUser.isjoined) && isEntryPeriod) {
                _this11.isWccPopUpModalShown = true;
              }
            case 5:
              _context12.next = 7;
              return useRankMatchStore().fetchMyUserInfos();
            case 7:
              if (_this11.getShownRankMatchMasters.length && !useRankMatchStore().isJoinedAny) {
                _this11.isRankEventPopUpModalShown = true;
              }

              //タイトルマッチ開催有無の判断
              //タイトルマッチを厳選する(トライアルマッチを取り抜く)
              titleMatchList = _this11.getShownTitleMatchMasters.filter(function (titleMatch) {
                var titleMatchId = titleMatch.titleMatchId.toString();
                //開催期間中のものだけにポップアップを出す
                //トライアルマッチのidは6桁、他のタイトルマッチは6桁以下かつ開催期間中のもの
                return titleMatchId.length < 6 && _this11.$dayjs().isSameOrBefore(_this11.$dayjs(titleMatch.eventPeriod.until * 1000));
              }); // タイトルマッチ参加有無
              if (!titleMatchList.length) {
                _context12.next = 14;
                break;
              }
              titleMatchJoined = false;
              _context12.next = 13;
              return Promise.all(titleMatchList.map( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(x) {
                  var userInfo;
                  return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) switch (_context11.prev = _context11.next) {
                      case 0:
                        _context11.next = 2;
                        return _this11.$duelsService.getMyTmUserInfo(x.titleMatchId);
                      case 2:
                        userInfo = _context11.sent;
                        if (userInfo.isjoined) {
                          titleMatchJoined = true;
                        }
                      case 4:
                      case "end":
                        return _context11.stop();
                    }
                  }, _callee11);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }()));
            case 13:
              if (!titleMatchJoined) {
                _this11.isTitleMatchEventPopUpModalShown = true;
              }
            case 14:
              //fg開催有無の判断
              currentFgList = _this11.getCurrentFgData.filter(function (fg) {
                return _this11.$dayjs().isSameOrBefore(_this11.$dayjs(fg.eventPeriod.until * 1000));
              });
              if (!currentFgList.length) {
                _context12.next = 22;
                break;
              }
              fgJoined = false;
              _context12.next = 19;
              return _this11.$questsService.getCurrentFgUserRankInfo();
            case 19:
              currentFgRankInfo = _context12.sent;
              //fg参加有無の判断
              fgJoined = currentFgRankInfo.some(function (x) {
                return x.ranking != 0;
              });
              if (!fgJoined) {
                _this11.isFgEventPopUpModalShown = true;
              }
            case 22:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }))();
    },
    logout: function logout() {
      var _this12 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return useAuthStore().signOut();
            case 2:
              window.location.href = _this12.localePath('index');
            case 3:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    }
  }
};